"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Section = _styledComponents.default.li.withConfig({
  displayName: "Section"
})(["font-weight:500;padding-right:1.6rem;"]);

var SubSection = _styledComponents.default.li.withConfig({
  displayName: "SubSection"
})(["font-weight:400;border-right:1px solid;padding-right:1.6rem;border-color:", ";color:", ";transition:0.2s;"], function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active ? theme.brand.primary : 'transparent';
}, function (_ref2) {
  var theme = _ref2.theme,
      active = _ref2.active;
  return active ? theme.typo.title : theme.labels.guaranteeText;
});

var Item = _styledComponents.default.li.withConfig({
  displayName: "Item"
})(["position:relative;padding-right:0;margin-bottom:0;"]);

var SectionContainer = _styledComponents.default.ul.withConfig({
  displayName: "SectionContainer"
})(["padding-right:0;font-family:", ";overflow:", ";opacity:", ";max-height:", ";transition:opacity 0.5s,max-height 0.5s;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, function (_ref4) {
  var active = _ref4.active;
  return active ? 'auto' : 'hidden';
}, function (_ref5) {
  var active = _ref5.active;
  return active ? '1' : '0';
}, function (_ref6) {
  var active = _ref6.active;
  return active ? '100vh' : '0';
});

SubSection.propTypes = {
  active: _propTypes.default.bool
};

var StyledSubNavigation = _styledComponents.default.ul.withConfig({
  displayName: "StyledSubNavigation"
})(["font-size:1.6rem;line-height:120%;font-family:", ";li{line-height:120%;text-align:right;margin-bottom:1rem;cursor:pointer;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.font;
});

var SubNavigation = /*#__PURE__*/(0, _react.forwardRef)(function (_ref8, ref) {
  var className = _ref8.className,
      children = _ref8.children,
      otherProps = _objectWithoutProperties(_ref8, ["className", "children"]);

  return /*#__PURE__*/_react.default.createElement(StyledSubNavigation, _extends({
    ref: ref,
    className: className
  }, otherProps), children);
});
SubNavigation.displayName = 'SubNavigation';
SubNavigation.Section = Section;
SubNavigation.Section.displayName = 'SubNavigation.Section';
SubNavigation.SubSection = SubSection;
SubNavigation.SubSection.displayName = 'SubNavigation.SubSection';
SubNavigation.Item = Item;
SubNavigation.SectionContainer = SectionContainer;
SubNavigation.SectionContainer.displayName = 'SubNavigation.SectionContainer';
SubNavigation.propTypes = {
  className: _propTypes.default.string,
  otherProps: _propTypes.default.object,
  children: _propTypes.default.node
};
var _default = SubNavigation;
exports.default = _default;